import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";

export const PermitDetailDialogSkeleton: React.FC = () => {
  return (
    <Stack spacing={2}>
      {/* Operator Information skeleton */}
      <Box>
        <Skeleton variant="text" width={120} height={20} />
        <Skeleton variant="text" width={200} height={28} />
        <Skeleton variant="text" width={180} height={20} />
      </Box>

      <Divider />

      {/* Basic Information skeleton */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Skeleton variant="text" width={80} height={16} />
          <Skeleton variant="text" width={120} height={24} />
        </Box>
        <Skeleton variant="rounded" width={80} height={24} />
      </Box>
      <Box>
        <Skeleton variant="text" width={100} height={16} />
        <Skeleton variant="text" width={160} height={24} />
      </Box>

      <Divider />

      {/* Validity Period skeleton */}
      <Box>
        <Skeleton variant="text" width={140} height={24} sx={{ mb: 1 }} />
        <Box display="flex" gap={4}>
          <Box>
            <Skeleton variant="text" width={80} height={16} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box>
            <Skeleton variant="text" width={80} height={16} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
        </Box>
      </Box>

      <Divider />

      {/* Vehicles skeleton */}
      <Box>
        <Skeleton variant="text" width={100} height={24} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" width="100%" height={60} />
      </Box>
    </Stack>
  );
};

export default PermitDetailDialogSkeleton;
